export default {
  pageDesc: 'Configure stations and devices by process. One pick station maps to a 36-slot seeding rack that can hold multiple orders',
  paramTitle: 'Dispatch Parameters',
  paramHint: 'The process decides which steps and fields are configurable',
  flowLabel: 'Process',
  flowTip: 'Full flow = pick then auto-continue to check; Pick only = pick step; Check only = check step. Decides which steps and fields are configurable.',
  flowAll: 'Full Flow',
  flowPick: 'Pick Only',
  flowChk: 'Check Only',
  flowNoteAll: 'Full flow: picking auto-continues to checking. Both stations and devices are configurable.',
  flowNotePick: 'Pick only: ends after pick close. Check station and device are locked.',
  flowNoteChk: 'Check only: no picking dependency. Pick station and device are locked.',
  pickStation: 'Pick Station',
  pickStationTip: 'Station where the rack docks for picking. One pick station maps to one seeding rack (4×9 = 36 frames). Not used in check-only flow.',
  chkStation: 'Check Station',
  chkStationTip: 'Station for checking, paired 1:1 with pick station (PW-01 ↔ RC-01). Not used in pick-only flow.',
  position: 'Dock Side',
  positionTip: 'Rack dock side at the station: Left L / Right R. Fixed on site and set by the dispatcher; combined with bay code into a full bay (e.g. L01A-2F).',
  positionL: 'Left L',
  positionR: 'Right R',
  pickDevice: 'Pick Device',
  pickDeviceTip: 'Robot that executes picking. Not used in check-only flow.',
  chkDevice: 'Check Device',
  chkDeviceTip: 'Robot that executes checking. Not used in pick-only flow.',
  lockPickStation: 'This process has no picking; station is locked',
  lockChkStation: 'This process has no checking; station is locked',
  lockPickDevice: 'This process has no picking; device is locked',
  lockChkDevice: 'This process has no checking; device is locked',
  expectTime: 'Expected Finish',
  expectTimeTip: 'Planned finish time for scheduling and overdue alerts.',
  devicePickIdle: 'TermiBot T1-001 (Pick · Idle · 96%)',
  devicePickBusy: 'TermiBot T1-003 (Pick · Running · Queued)',
  devicePickIdle2: 'TermiBot T1-005 (Pick · Idle · 88%)',
  deviceChkIdle: 'TermiBot T1-002 (Check · Idle · 92%)',
  deviceChkBusy: 'TermiBot T1-004 (Check · Running · Queued)',
  deviceChkIdle2: 'TermiBot T1-006 (Check · Idle · 90%)',
  devicePickLabel: '{sn} (Pick)',
  deviceChkLabel: '{sn} (Check)',
  devicePickOnline: '{sn} (Pick · Battery {battery})',
  deviceChkOnline: '{sn} (Check · Battery {battery})',
  devicePickOffline: '{sn} (Pick · Offline)',
  deviceChkOffline: '{sn} (Check · Offline)',
  deviceEmpty: 'No devices available',
  stationPw01: 'PW-01 (Rack B103A-19 · Free 28/36)',
  stationPw02: 'PW-02 (Rack B103A-20 · Free 36/36)',
  stationPw03: 'PW-03 (Rack B103A-21 · Free 12/36)',
  stationRc01: 'RC-01 (follows pick station PW-01)',
  stationRc02: 'RC-02 (follows pick station PW-02)',
  stationRc03: 'RC-03 (follows pick station PW-03)',
  stationPickLabel: '{code} (Rack {basket} · {status})',
  stationChkFollow: '{code} (follows pick station {pick})',
  stationChkLabel: '{code} (Rack {basket} · {status})',
  stationStatusIdle: 'Idle',
  stationStatusBusy: 'Busy',
  stationEmpty: 'No stations available',
  orderTitle: '① Select Orders (multi)',
  orderHint: 'Click orders to include them. One seeding rack can hold multiple orders',
  orderSelCnt: '{n} selected',
  orderMeta: '{skuCount} SKUs · {qty} pcs',
  orderLoading: 'Loading orders…',
  orderEmpty: 'No orders available',
  createOrder: 'Create Order',
  createOrderTitle: 'Create Order',
  createOrderColProduct: 'Product',
  createOrderColQty: 'Qty',
  createOrderSkuPlaceholder: 'Select product',
  createOrderSkuRequired: 'Please select a product for each row',
  createOrderSkuDuplicate: 'Products must be unique',
  createOrderQtyPlaceholder: 'Qty',
  createOrderQtyRequired: 'Please enter quantity for each row',
  createOrderStopPos: 'Dock',
  createOrderStopPosPlaceholder: 'Select dock side',
  createOrderStopPosRequired: 'Please select dock side',
  createOrderLayer: 'Shelf Layer',
  createOrderLayerPlaceholder: 'e.g. L1',
  createOrderLayerRequired: 'Please enter shelf layer',
  createOrderBoxPos: 'Carton',
  createOrderBoxPosPlaceholder: 'Enter carton position',
  createOrderBoxPosRequired: 'Please enter carton position',
  createOrderTotal: 'Total qty',
  createOrderAdd: '+ Add row',
  createOrderRemove: 'Remove',
  createOrderEmpty: 'Add SKU rows',
  createOrderOk: 'OK',
  createOrderCancel: 'Cancel',
  createOrderSuccess: 'Order created',
  createOrderFail: 'Failed to create order',
  skuTitle: '② Select SKU & Qty',
  skuHint: 'Aggregated from selected orders; unwanted SKU rows can be removed',
  skuEmpty: 'Select orders above to auto-fill SKU lines here.',
  skuSoftNote: 'Qty comes from order demand and is not editable. One order maps to one seeding frame.',
  remove: 'Remove',
  colOrder: 'Order',
  colSku: 'SKU',
  colName: 'Item',
  colForm: 'Form',
  colLocShort: 'Bay',
  colStopPos: 'Dock',
  colLayer: 'Shelf Layer',
  colBoxPos: 'Carton',
  colBarcode: 'Barcode',
  stopPosLeft: 'Left L',
  stopPosRight: 'Right R',
  colPickQty: 'Pick Qty',
  colAction: 'Action',
  wallTitle: '③ Seeding Rack',
  wallHint: 'Frames are auto-assigned per order. Click to unbind / rebind (one order per frame)',
  wallUsage: 'Used {n} / {total}',
  wallLoading: 'Loading frames…',
  wallAuto: 'Re-auto allocate',
  wallTip: 'Occupied frame = unbind; idle frame = bind next unbound order (one order per frame)',
  wallUnbound: '{n} unbound orders',
  wallBoundAll: 'All orders bound',
  wallEmpty: 'No frames bound yet — select orders first.',
  colFrame: 'Frame',
  colOrderFull: 'Order',
  colSkuCount: 'SKU Count',
  colSkuQty: 'SKU × Qty',
  colNeed: 'Need',
  colStatus: 'Status',
  pendingDrop: 'Pending',
  frameOffline: 'Off shelf',
  frameTipBound: '{pos} · {order} · {skuCount} SKUs · {qty} pcs (click to unbind)',
  frameTipFreeBind: '{pos} · Idle (click to bind next unbound order)',
  frameTipFree: '{pos} · Idle',
  frameTipOffline: '{pos} · Off shelf',
  toastFrameOffline: 'This frame is off shelf and cannot be bound',
  summaryTitle: 'Dispatch Summary',
  sFlow: 'Process',
  sPickSt: 'Pick Station',
  sChkSt: 'Check Station',
  sPos: 'Dock Side',
  sFullBay: 'Full Bay Code',
  sOrders: 'Orders',
  sSrc: 'SKU / Bay',
  sCount: 'Item Qty',
  sFrames: 'Frame Occupancy',
  sPickDev: 'Pick Device',
  sChkDev: 'Check Device',
  sPolicy: 'Exception Policy',
  policyText: 'Hold the line on business exceptions, wait for a human decision, keep an audit trail',
  unselected: 'Not selected',
  undetermined: 'Unresolved',
  pendingSku: 'Select SKU',
  notInvolved: '— (N/A)',
  ordersCount: '{n}',
  countText: '{n} pcs',
  skuLoc: '{sku} → {loc}',
  submit: 'Submit Dispatch',
  reset: 'Reset',
  submitNoteAll: 'Submit creates a full-flow task and occupies frames; pick close auto-continues to check.',
  submitNotePick: 'Submit creates a pick-only task and occupies frames; ends after pick close.',
  submitNoteChk: 'Submit creates a check-only task; verifies existing frames without occupying new ones.',
  toastSelectOrder: 'Select at least one order',
  toastSkuEmpty: 'SKU list is empty; check selected orders',
  toastSelectWall: 'Configure the seeding rack (at least one frame)',
  toastNoUnbound: 'No unbound orders left',
  toastOrderNoSku: 'This order has no SKU lines',
  toastWallAuto: 'Frames re-bound by order sequence',
  toastSubmit: 'Dispatch submitted: task {no} covers {n} orders',
  toastSubmitFail: 'Dispatch failed, please try again later',
  toastReset: 'Dispatch parameters reset',
}
